import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { closeModal, openSubModal, saveSelectedLifeEvent } from '../../redux/lifePlan';
import { generateYearsByMemberAge, ModalName } from '../../shared/constants/global';
import LifePlanModal from '../../shared/components/modal';
import { LifePlansImages } from '../../assets/images';
import { Form, Field, Formik } from 'formik';
import InputText from '../../shared/components/input-field';
import CommaInput from '../../shared/components/comma-input-field';
import SelectFieldSecond from '../../shared/components/select-field-second';
import { YupSchema } from '../../shared/constants/validators';
import { cloneDeep } from "lodash";

const {imgEatout1, imgEatout2, imgEatout3, imgEatout4, imgEatout5, imgEatout6, imgEatout7}= LifePlansImages;
const arrImages = [imgEatout1, imgEatout2, imgEatout3, imgEatout4, imgEatout5, imgEatout6, imgEatout7];

export default function EventEatoutModal(props) {
  const { t } = useTranslation('eventEatoutModal');
  const tGlobal = useTranslation('global').t;
  const dispatch = useDispatch();
  const { lifeEvent } = props;
  const uuid = useSelector(state => state.lifeEventSelected.uuid);
  const storeLifeEvents = useSelector(state => state.life_plan.life_event);

  const formState = useRef();

  const [checkShow, setCheckShow] = useState(false);
  const [selectedValue, setSelectedValue] = useState('');
  const [initialValues, setInitialValues] = useState({ ...props.lifeEvent, other: { ...props.lifeEvent.other } });

  const validateSchema = useMemo(() => {
    return new YupSchema(t).eventEatout;
  }, []);

  useEffect(() => {
    const values = { ...props.lifeEvent, other: { ...props.lifeEvent.other } }
    setInitialValues(values)
    setCheckShow(values.other.detail == 7)
    if (uuid) {
      let cycleYear = storeLifeEvents.find((event) => event.uuid === uuid).year
      formState.current.setFieldValue("year", cycleYear);
    }
  }, [props.lifeEvent])

  const handleClose = () => {
    dispatch(closeModal());
  }

  const getDetailName = (detail, data) => {
    switch (detail) {
      case 1:
        return "手軽な外食（月２回程度）"
      case 2:
        return "手軽な外食（毎週末）"
      case 3:
        return "少し高級な外食（月2回程）"
      case 4:
        return "少し高級な外食（それぞれ毎週末）"
      case 5:
        return "高級外食（月２回程度）"
      case 6:
        return "高級外食（毎週末）"
      case 7:
        return data.other?.custom || ""
      default:
        return ""
    }
  }

  const prepareData = (values) => {
    const tempData = cloneDeep(values);
    const params = {
      ...tempData,
      other: {
        ...tempData.other,
        detail_name: getDetailName(+tempData.other?.detail, tempData)
      }
    }
    return params;
  }

  const handleSubmitFinal = async () => {
    await formState.current.setFieldTouched();
    await formState.current.validateForm()

    if (!formState.current.isValid) {
      console.log('form invalid');
      return;
    }
    const { values } = formState.current;
    try {
      const data = prepareData(values);
      dispatch(saveSelectedLifeEvent(data));
    } catch (e) {
      console.log(e)
    }
  }

  const yearMapping = {}
  generateYearsByMemberAge().map((y) => yearMapping[y.year] = y.age)

  const renderYearFromNow = (year) => {
    return `${subYear(year)}歳（${year}年）`
  }

  const subYear = (year) => {
    const age = yearMapping[year];
    return age;
  }

  const onSelect = (data) => {
    setSelectedValue(+data)
    if (+formState.current.values.end_year < +data) {
      formState.current.setFieldValue("end_year", +data);
    }
  }

  const dataEndYear = useMemo(() => {
    if (!selectedValue) {
      return Object.keys(yearMapping).filter(ele => {
        if (uuid) {
          let cycleYear = storeLifeEvents.find((event) => event.uuid === uuid).year
          return +ele >= cycleYear
        } else {
          return +ele >= initialValues.year
        }
      });
    } else {
      return Object.keys(yearMapping).filter(ele => {
        return +ele >= +selectedValue;
      });
    }
  }, [selectedValue, initialValues.year])

  const handleRemove = () => {
    dispatch(openSubModal(ModalName.LIFEPLAN_CONFIRM_DELETE))
  }

  return <LifePlanModal name={ModalName.LIFEPLAN_EVENT_EATOUT}>
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={validateSchema}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formikProps) => {
        const { values, setFieldValue, handleSubmit } = formikProps;
        formState.current = formikProps;

        return (
          <Form onSubmit={handleSubmit}>
            <div className="popupBox">
              <div className="popupInner">
                <div className="lifeplanPopup">
                  <h2>{t('label')}</h2>
                  <div className="popupContents">
                    <div className="popupContentsCover">
                      <div id="checkshow1" className="whiteBox checkShowToggle radioImgBox pad24 padBottom8">
                        <ul className="radioImgBtnList rowList">
                          {[...Array(7)].map((e, i) => {
                            return <li key={i}><label className={`radioBtn ${i + 1 == values.other.detail ? "checked" : ""}`}>
                                    <Field onClick={() => setCheckShow(i == 6)}
                                      type="radio" value={i + 1} name="other.detail" className="toggle_hide" />
                                    <img src={arrImages[i]} /><span>{t(`options.${i}`)}<br className="br_sp"/>{t(`cost.${i}`)}</span>
                                  </label></li>
                          })}
                        </ul>
                      </div>
                    </div>
                    <dl className="formSty lifeplanImgBtnBox marB40">
                      <dt id="checkShow1-ttl" className={`checkShow1 ${!checkShow ? 'hiddenTtl' : ''}`}>{t('custom')}</dt>
                      <dd id="checkShow1-item" className={`checkShow1 formTtlSty nowrap ${!checkShow ? 'hiddenItem' : ''}`}>
                        <div className="wid400">
                          <Field className="toggle-item" type="text" component={InputText} name="other.custom" placeholder={t('customPlaceholder')} disabled={!checkShow} dF={true} />
                        </div>
                        <dl className="formTtlSty nowrap wid380 marL40">
                          <dt>{t('eatoutCost')}</dt>
                          <dd>
                            <Field className="wid120" placeholder="1" type="text" component={CommaInput} name="other.price" disabled={!checkShow} secondLabel={t('unit')} setFieldValue={setFieldValue} />
                          </dd>
                        </dl>
                      </dd>
                      <dt>{tGlobal('start')}</dt>
                      <dd className="formTtlSty nowrap">
                        <div className="dF aisC maxWidth400">
                          <Field component={SelectFieldSecond} width="wid200" name="year" customChange={onSelect} options={Object.keys(yearMapping)} display_options={renderYearFromNow} />
                        </div>
                        <dl className="formTtlSty nowrap wid380 marL40">
                          <dt>{tGlobal('end')}</dt>
                          <dd>
                            <Field component={SelectFieldSecond} width="wid200" name="end_year" options={dataEndYear} display_options={renderYearFromNow} />
                          </dd>
                        </dl>
                      </dd>
                    </dl>
                    <div className="popupBtnBox">
                      <ul className="btnList col2">
                        <li><button type="button" className="btnSty-back" onClick={handleClose}>{tGlobal('cancel')}</button></li>
                        <li><button type="submit" className="btnSty-send" onClick={handleSubmitFinal}>{tGlobal('send')}</button></li>
                        { lifeEvent && lifeEvent.uuid && <li className="btnSty-delete"><button type="button" onClick={handleRemove}>{tGlobal('delete')}</button></li> }
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )
      }}
    </Formik>
  </LifePlanModal>
}
